<script lang="ts">
	import { Storyblok } from '#library/storyblok.svelte.ts'
	import Subnav from '#components/subnav.svelte'
	import type { Page } from '#library/types.ts'
	import { page } from '$app/state'
	import { findObject } from 'kitto'

	interface Props {
		data: Storyblok<Page>
	}

	let { data }: Props = $props()

	type Block = NonNullable<Page['content']['blocks']>[number]
	type BlockWithAnchor = Block & { anchor: string }

	function anchor_blocks(block: Block): block is BlockWithAnchor {
		return 'anchor' in block && typeof block.anchor === 'string' && block.anchor !== ''
	}

	function to_id(str?: string) {
		return str
			?.toLowerCase()
			.replace(/\s+/g, '_')
			.replace(/[^a-z0-9_]/g, '')
	}

	const anchors = $derived(
		data.story?.content.blocks?.filter(anchor_blocks).map(block => ({
			id: to_id(block.anchor),
			name: block.anchor ?? ''
		})) ?? []
	)
</script>

<svelte:head>
	{#if data.story?.content.no_index}
		<meta name="robots" content="noindex" />
	{/if}
</svelte:head>

{#if data.story?.content.blocks?.length}
	<Subnav items={anchors} />
	{#each data.story?.content.blocks as blok (blok._uid)}
		{@const shared = blok.id && findObject(page.data.layout.blocks, 'id', blok.id)}
		{@const anchor = 'anchor' in blok ? to_id(blok.anchor) : undefined}

		<Storyblok.Block blok={{ ...(shared || blok), anchor }} />
	{/each}
{/if}
